"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.cssAnchorName = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _Pagination = _interopRequireDefault(require("@insided/shared/uikit/Pagination"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _ChevronDown = _interopRequireDefault(require("@insided/shared/icons/ChevronDown"));

var _dropdown = _interopRequireWildcard(require("@insided/deprecated-preact-components/design-system-components/dropdown"));

var _urlGenerator = require("@insided/deprecated-preact-components/utils/urlGenerator");

var _HubAI = require("@insided/shared/modules/HubAI");

var _TopicRepliesEmptyStatus = _interopRequireDefault(require("../../TopicRepliesEmptyStatus"));

var _constants = require("@insided/shared/modules/Content/ThreadedReplies/constants");

var _TopicReply = _interopRequireDefault(require("./TopicReply"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var TopicReplies = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(TopicReplies, _Component);

  var _super = _createSuper(TopicReplies);

  function TopicReplies() {
    var _this;

    (0, _classCallCheck2.default)(this, TopicReplies);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "SORT_OPTIONS", [{
      label: (0, _preact.h)(_phrase.default, {
        p: "Oldest first"
      }),
      key: _constants.SORT_KEYS.OLDEST_FIRST,
      url: "?sort=".concat(_constants.SORT_KEYS.OLDEST_FIRST, "#comments")
    }, {
      label: (0, _preact.h)(_phrase.default, {
        p: "Newest first"
      }),
      key: _constants.SORT_KEYS.NEWEST_FIRST,
      url: "?sort=".concat(_constants.SORT_KEYS.NEWEST_FIRST, "#comments")
    }, {
      label: (0, _preact.h)(_phrase.default, {
        p: "Best voted"
      }),
      key: _constants.SORT_KEYS.BEST_VOTED,
      url: "?sort=".concat(_constants.SORT_KEYS.BEST_VOTED, "#comments")
    }]);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "DEFAULT_SORT_OPTION", _this.SORT_OPTIONS[0]);
    return _this;
  }

  (0, _createClass2.default)(TopicReplies, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var _ref, replies, postId, matchedReplyByPublicId, matchedReplyByPrivateId;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _ref = this.props || {}, replies = _ref.replies;

                if (replies !== null && replies !== void 0 && replies.length) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return");

              case 3:
                postId = new URLSearchParams(window.location.search).get('postid');

                if (postId) {
                  _context.next = 6;
                  break;
                }

                return _context.abrupt("return");

              case 6:
                matchedReplyByPublicId = replies.find(function (reply) {
                  return reply.publicReplyId.toString() === postId;
                });
                matchedReplyByPrivateId = replies.find(function (reply) {
                  return reply.id.toString() === postId;
                });

                if (matchedReplyByPublicId) {
                  window.location.hash = '#post' + postId;
                } else if (matchedReplyByPrivateId) {
                  window.location.hash = '#post' + matchedReplyByPrivateId.publicReplyId;
                }

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "renderSortingDropdown",
    value: function renderSortingDropdown() {
      var _this$SORT_OPTIONS$fi;

      var _this$props = this.props,
          totalReplies = _this$props.totalReplies,
          type = _this$props.type,
          currentSort = _this$props.currentSort;
      var topicUrl = typeof window !== 'undefined' ? window.location.origin + window.location.pathname : '';
      var selectedSortOption = (_this$SORT_OPTIONS$fi = this.SORT_OPTIONS.find(function (sort) {
        return sort.key === currentSort;
      })) !== null && _this$SORT_OPTIONS$fi !== void 0 ? _this$SORT_OPTIONS$fi : this.DEFAULT_SORT_OPTION;

      if (totalReplies <= 1 || type === 'productUpdate') {
        return null;
      }

      return (0, _preact.h)("div", {
        className: "list__items--sort-test qa-topic-sort-dropdown"
      }, (0, _preact.h)(_dropdown.default, {
        isControl: false,
        openAlwaysOnTriggerClick: true,
        size: "full-width",
        align: "right",
        popupName: "sort-dropdown",
        closeOnDropdownClick: true,
        trigger: (0, _preact.h)("div", {
          className: "qa-reply-sort-dropdown dropdown-links__active-sort"
        }, (0, _preact.h)("span", null, selectedSortOption.label), (0, _preact.h)(_ChevronDown.default, {
          width: 16,
          height: 16
        }))
      }, this.SORT_OPTIONS.filter(function (sort) {
        return sort.key !== selectedSortOption.key;
      }).map(function (sort) {
        return (0, _preact.h)(_dropdown.DropdownItem, {
          key: sort.key
        }, (0, _preact.h)("a", {
          href: (0, _absoluteUrlRuntime.resolveUrl)("".concat(topicUrl, "?sort=").concat(sort.key, "#comments"))
        }, sort.label));
      })));
    }
  }, {
    key: "renderReplies",
    value: function renderReplies() {
      var _this$props2 = this.props,
          replies = _this$props2.replies,
          translatedReplies = _this$props2.translatedReplies,
          topic = _this$props2.topic,
          bestAnswer = _this$props2.bestAnswer,
          currentUser = _this$props2.currentUser,
          canMarkBestAnswer = _this$props2.canMarkBestAnswer,
          type = _this$props2.type,
          attachmentCdn = _this$props2.attachmentCdn,
          disableFileAttachments = _this$props2.disableFileAttachments,
          unlimitedEditPermission = _this$props2.unlimitedEditPermission,
          authors = _this$props2.authors,
          isTranslationInProgress = _this$props2.isTranslationInProgress,
          showPostActions = _this$props2.showPostActions;

      var _ref2 = topic || {},
          title = _ref2.title,
          authorId = _ref2.authorId,
          topicId = _ref2.id;

      var isTopicAuthorAnonymous = authorId === '';
      var topicAuthorId = String(authorId);
      var topicUrl = typeof window !== 'undefined' ? window.location.pathname : '';
      return replies.map(function (reply, idx) {
        var _bestAnswer$publicRep;

        var replyId = reply.publicReplyId,
            authorId = reply.authorId,
            attachments = reply.attachments;
        var replyAuthorId = authorId;
        var replyAuthor = authors === null || authors === void 0 ? void 0 : authors[replyAuthorId];
        return (0, _preact.h)(_TopicReply.default, {
          key: replyId,
          parentTopicTitle: title,
          currentUser: currentUser,
          displayAuthor: !isTopicAuthorAnonymous && (replyAuthorId === null || replyAuthorId === void 0 ? void 0 : replyAuthorId.toString()) === topicAuthorId,
          parentTopicId: Number(topicId),
          reply: reply,
          translatedReplyContent: translatedReplies[idx],
          parentTopicUrl: topicUrl,
          canMarkBestAnswer: canMarkBestAnswer,
          contentType: type,
          attachmentCdn: attachmentCdn,
          isBestAnswer: (bestAnswer === null || bestAnswer === void 0 ? void 0 : (_bestAnswer$publicRep = bestAnswer.publicReplyId) === null || _bestAnswer$publicRep === void 0 ? void 0 : _bestAnswer$publicRep.toString()) === reply.publicReplyId.toString(),
          replyAttachments: attachments !== null && attachments !== void 0 ? attachments : [],
          isLastItem: replies.length === idx + 1,
          disableFileAttachments: disableFileAttachments,
          unlimitedEditPermission: unlimitedEditPermission,
          showReputation: replyAuthor ? Boolean(replyAuthor.showReputation) : false,
          showBadges: replyAuthor ? Boolean(replyAuthor.showBadges) : false,
          authors: authors,
          isAllRepliesTranslationInProgress: isTranslationInProgress,
          showPostActions: showPostActions
        });
      });
    }
  }, {
    key: "renderPagination",
    value: function renderPagination() {
      var _this$props3 = this.props,
          totalPages = _this$props3.totalPages,
          currentRepliesPage = _this$props3.currentRepliesPage;
      if (totalPages <= 1) return null;
      return (0, _preact.h)(_Pagination.default, {
        totalPageCount: totalPages,
        currentPage: currentRepliesPage,
        generateNewUrl: _urlGenerator.generateNewUrl
      });
    }
  }, {
    key: "renderHeader",
    value: function renderHeader() {
      var _this$props4 = this.props,
          totalReplies = _this$props4.totalReplies,
          isTranslationInProgress = _this$props4.isTranslationInProgress;
      return (0, _preact.h)("header", {
        className: "list__items--header qa-topic-reply-box-header"
      }, (0, _preact.h)("div", {
        className: "topic-replies__header--left"
      }, (0, _preact.h)("h2", {
        className: "qa-total-replies"
      }, (0, _preact.h)(_phrase.default, {
        p: totalReplies ? '{n} Reply|{n} Replies' : 'no.replies',
        count: {
          n: totalReplies.toString()
        }
      }))), (0, _preact.h)("nav", {
        className: "topic-replies__header-item-list",
        "aria-live": "polite",
        "aria-busy": isTranslationInProgress
      }, this.renderSortingDropdown()));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
          replies = _this$props5.replies,
          showFirstToReplyBanner = _this$props5.showFirstToReplyBanner;
      return (0, _preact.h)("div", {
        className: "topic-replies__wrapper",
        id: "comments"
      }, this.renderHeader(), replies.length ? (0, _preact.h)("div", {
        className: "topic-reply-box-wrapper"
      }, this.renderPagination(), this.renderReplies(), this.renderPagination()) : showFirstToReplyBanner && (0, _preact.h)(_TopicRepliesEmptyStatus.default, null));
    }
  }], [{
    key: "updateSort",
    value: function updateSort(sort) {
      if (typeof window === 'undefined') return;
      window.location.href = "".concat(window.location.pathname, "?sort=").concat(sort, "#comments");
    }
  }]);
  return TopicReplies;
}(_preact.Component);

var _default = (0, _HubAI.withOnDemandTranslationProps)(TopicReplies, ['isTranslationInProgress', 'translatedReplies']);

exports.default = _default;
var cssAnchorName = 'topic-replies';
exports.cssAnchorName = cssAnchorName;